import { Navigate } from "react-router-dom";

export const MODERN_INBOX_ROUTE = "/app/inbox/chatinbox";

export default function LegacyInboxRedirect() {
  return <Navigate to={MODERN_INBOX_ROUTE} replace />;
}
